import type { ComponentType, FC, ReactChild } from 'react';
import React from 'react';

import type { IZIndexService } from './../ricos-types/index.js';

type ZIndexContextProps = {
  zIndexService: IZIndexService;
  children: ReactChild;
};

export const ZIndexContext = React.createContext<IZIndexService>(null as unknown as IZIndexService);

export const ZIndexContextProvider: FC<ZIndexContextProps> = ({ zIndexService, children }) => (
  <ZIndexContext.Provider value={zIndexService}>{children}</ZIndexContext.Provider>
);

export function withZIndexContext<T = any>(Component: ComponentType<T>) {
  return (props: T) => {
    return (
      <ZIndexContext.Consumer>
        {(value: IZIndexService) => <Component {...props} zIndexService={value} />}
      </ZIndexContext.Consumer>
    );
  };
}
